var get = require("object-path").get,
    translations;

/**
 * Translate a duration in seconds to a humanized string. Optionally abbreviate
 * units for shorter strings.
 *
 * @param    {Number}   seconds     The duration in seconds
 * @param    {String}   language    The language in 2-letter notation
 * @param    {Boolean}  abbreviate  Whether to abbreviate the units
 * @returns  {String}   The humanized timespan.
 * @throws   Throws an error if the requested language isn't supported
 */
module.exports = function(seconds, language, abbreviate) {
    var path = [],
        unit,
        duration;

    // Unsupported language
    if (!translations[language]) {
        throw new Error("Unsupported language for humanized timespan: " + String(language));
    }

    // Work out unit and duration
    if (seconds < 60) {
        unit     = "second";
        duration = Math.round(seconds);
    }
    else if (seconds < 60 * 60) {
        unit     = "minute";
        duration = Math.round(seconds / 60);
    }
    else if (seconds < 60 * 60 * 24) {
        unit     = "hour";
        duration = Math.round(seconds / 60 / 60);
    }
    else if (seconds < 60 * 60 * 24 * 7) {
        unit     = "day";
        duration = Math.round(seconds / 60 / 60 / 24);
    }
    else if (seconds < 60 * 60 * 24 * 30) {
        unit     = "week";
        duration = Math.round(seconds / 60 / 60 / 24 / 7);
    }
    else if (seconds < 60 * 60 * 24 * 365) {
        unit     = "month";
        duration = Math.round(seconds / 60 / 60 / 24 / 30);
    }
    else {
        unit     = "year";
        duration = Math.round(seconds / 60 / 60 / 24 / 365);
    }

    // Work out translated unit
    path.push(String(language));
    path.push(abbreviate ? "abbreviated" : "full");
    path.push(unit);
    path.push(Math.abs(Number(duration)) <= 1 ? "0" : "1");
    unit = get(translations, path.join("."), null);

    return [duration, unit].join(" ");
};

translations = {
    en: {
        full: {
            second: ["second", "seconds"],
            minute: ["minute", "minutes"],
            hour:   ["hour", "hours"],
            day:    ["day", "days"],
            week:   ["week", "weeks"],
            month:  ["month", "months"],
            year:   ["year", "years"]
        },
        abbreviated: {
            second: ["sec", "sec"],
            minute: ["min", "min"],
            hour:   ["hr", "hrs"],
            day:    ["day", "days"],
            week:   ["wk", "wks"],
            month:  ["mth", "mo"],
            year:   ["yr", "yrs"]
        }
    },
    nl: {
        full: {
            second: ["seconde", "seconden"],
            minute: ["minuut", "minuten"],
            hour:   ["uur", "uur"],
            day:    ["dag", "dagen"],
            week:   ["week", "weken"],
            month:  ["maand", "maanden"],
            year:   ["jaar", "jaar"]
        },
        abbreviated: {
            second: ["sec", "sec"],
            minute: ["min", "min"],
            hour:   ["uur", "uur"],
            day:    ["dg", "dgn"],
            week:   ["wk", "wkn"],
            month:  ["mnd", "mdn"],
            year:   ["jr", "jr"]
        }
    },
    de: {
        full: {
            second: ["Sekunde", "Sekunden"],
            minute: ["Minute", "Minuten"],
            hour:   ["Stunde", "Stunden"],
            day:    ["Tag", "Tage"],
            week:   ["Woche", "Wochen"],
            month:  ["Monat", "Monate"],
            year:   ["Jahr", "Jahre"]
        },
        abbreviated: {
            second: ["Sek", "Sek"],
            minute: ["Min", "Min"],
            hour:   ["Std", "Std"],
            day:    ["T", "T"],
            week:   ["W", "W"],
            month:  ["Mt", "Mo"],
            year:   ["J", "J"]
        }
    }
};
